export default "__VITE_PUBLIC_ASSET__fdb74ea6__"